class changerListViewController{
  constructor(){
    'ngInject';
  }
  set( width ){
    let className = `col-xs-12 col-sm-${width} col-list-element`;
    this.app.ActiveCache.cacheSet( 'app.grid.listElement', className );
    this.app.grid.listElement = className;
  }
}

export default changerListViewController;


/** WEBPACK FOOTER **
 ** ./frontend/components/active/changer-list-view/changer-list-view.controller.js
 **/